import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'ShopPayout';

const ShopPayoutApi: any = baseApi(endpoint);

export default ShopPayoutApi;